// extracted by mini-css-extract-plugin
module.exports = {"tafsirMessage":"TafsirMessage_tafsirMessage__Gr_S9"};